export namespace AssetRegisterConstants {

    export enum DateFormat {
        DateFormat = 'YYYY-MM-DD',
        DateTimeFormat = 'YYYY-MM-DD HH:mm:ss'
    }

    export enum Status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        DRAFT = 'DRAFT',
        REGISTERED = 'REGISTERED'
    }
    export enum AssetType {
        PROPERTY_PLANT_EQUIPMENT = 'PROPERTY_PLANT_EQUIPMENT',
        LONG_TERM_INVESTMENT = 'LONG_TERM_INVESTMENT',
        INTANGIBLE_ASSET = 'INTANGIBLE_ASSET'
    }
    export enum TransType {
        ADJUSTMENT = 'ADJUSTMENT',
        ASSET_HELD_FOR_SALE = 'ASSET_HELD_FOR_SALE',
        DISPOSAL = 'DISPOSAL',
        ACQUISITION = 'ACQUISITION'
    }
} 